import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@KristianIV/common-ui";
import styles from "./RouteButton.module.css";

interface RouteButtonProps {
  to: string;
  icon?: React.ReactNode;
  size?: "small" | "normal";
  children: React.ReactNode;
}

/**
 * A library Button that navigates. Wraps it in a router Link so middle-click and
 * keyboard navigation work; replace with Button's own link support once common-ui has an `as` prop.
 */
const RouteButton = ({ to, icon, size, children }: RouteButtonProps) => (
  <Link to={to} className={styles.link}>
    <Button icon={icon} size={size}>
      {children}
    </Button>
  </Link>
);

interface ExternalButtonProps {
  href: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export const ExternalButton = ({ href, icon, children }: ExternalButtonProps) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className={styles.link}>
    <Button icon={icon}>{children}</Button>
  </a>
);

export default RouteButton;
